import { IRiskViewSettingsItem } from 'types/graphql'

export const FIELD_IDS = {
  PARENT: 'PARENT',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  CREATED_BY: 'createdBy',
  UPDATED_BY: 'updatedBy'
} as const

export const getVisibleFields = (fields: IRiskViewSettingsItem[]) => {
  const isActive = (fieldId: string) =>
    fields?.some(({ fieldId: id, active }) => id === fieldId && (active ?? true)) ?? false

  return {
    showParent: isActive(FIELD_IDS.PARENT),
    showCreatedAt: isActive(FIELD_IDS.CREATED_AT),
    showUpdatedAt: isActive(FIELD_IDS.UPDATED_AT),
    showCreatedBy: isActive(FIELD_IDS.CREATED_BY),
    showUpdatedBy: isActive(FIELD_IDS.UPDATED_BY)
  }
}
